(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('compendium', {
            parent: 'entity',
            url: '/compendium',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Compendiums'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium/compendiums.html',
                    controller: 'CompendiumController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('compendium-detail.edit', {
            parent: 'compendium-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium/compendium-dialog.html',
                    controller: 'CompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Compendium', function(Compendium) {
                            return Compendium.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium.new', {
            parent: 'compendium',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium/compendium-dialog.html',
                    controller: 'CompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                description: null,
                                wGroup: null,
                                specimen: null,
                                units: null,
                                id: null,
                                cutOff: null,
                                abbr: null,
                                compendiumReportGroup: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compendium', null, { reload: 'compendium' });
                }, function() {
                    $state.go('compendium');
                });
            }]
        })
        .state('compendium.edit', {
            parent: 'compendium',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium/compendium-dialog.html',
                    controller: 'CompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Compendium', function(Compendium) {
                            return Compendium.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium', null, { reload: 'compendium' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium.delete', {
            parent: 'compendium',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium/compendium-delete-dialog.html',
                    controller: 'CompendiumDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Compendium', function(Compendium) {
                            return Compendium.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium', null, { reload: 'compendium' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
